import request from '@/assets/js/utils/request'

export function selfRota(){
  return request({
    url: 'AppClient/Rota/Rotas',
    method: 'post'
  })
}

export function allRota(){
  return request({
    url: 'AppClient/Rota/AllRota',
    method: 'post'
  })
}


// WEBPACK FOOTER //
// ./src/assets/js/api/rota.js